/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubActiveReferralInventoryItem { 
    crdReferralId?: string;
    pcmsIndividualId?: number;
    pcmsReferralId?: number;
    population?: PcmsHubActiveReferralInventoryItem.PopulationEnum;
}
export namespace PcmsHubActiveReferralInventoryItem {
    export const PopulationEnum = {
        Adult: 'ADULT',
        Juvenile: 'JUVENILE'
    } as const;
    export type PopulationEnum = typeof PopulationEnum[keyof typeof PopulationEnum];
}


